import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";

export type EllipsesMenuTableNutritionProps = {
  onDelete: () => void;
};

const EllipsesMenuTableNutrition: React.FC<EllipsesMenuTableNutritionProps> = ({
  onDelete,
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="block text-gray-400 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-5 w-5"
        />
      </MenuButton>
      <MenuItems className="absolute right-0 z-50 w-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none">
        <MenuItem>
          <a
            onClick={onDelete}
            className="block px-3 py-1 text-sm leading-6 text-gray-600 hover:text-gray-900"
          >
            {t("general.delete")}
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuTableNutrition;
